import React from 'react';
import './MyFooter.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub, faLinkedin, faMedium } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';

const MyFooter = () => {
    const navigate = useNavigate();
    return (
        <footer className="footer">
            <div className="container">
                <div className="text-center">
                    <a href="https://github.com/thejakia1" target="_blank" rel="noopener noreferrer" >
                        <FontAwesomeIcon icon={faGithub} /></a>
                    <a href="https://www.linkedin.com/in/thejakia1/" target="_blank" rel="noopener noreferrer" >
                        <FontAwesomeIcon icon={faLinkedin} /></a>
                    <a href="https://jakia-official.medium.com/" target="_blank" rel="noopener noreferrer" title="Medium Blog">
                        <FontAwesomeIcon icon={faMedium} /></a>
                    <a onClick={() => navigate("/")} href="#contact">
                        <FontAwesomeIcon icon={faEnvelope} /></a>
                    <p style={{color: 'rgb(110, 112, 131)'}} className="pt-3">&copy; Copyright by Jakia {new Date().getFullYear()}, All Rights reserved</p>
                </div>
            </div>
        </footer>
    );
};

export default MyFooter;